var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManual(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_330",
    "data-name": "\\uADF8\\uB8F9 330",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 8.956,
    height: 9.955,
    viewBox: "0 0 8.956 9.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke: rgba(0,0,0,0);\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3, .cls-4 {\r\n        stroke: #071340;\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_80",
    "data-name": "\\uD328\\uC2A4 80",
    className: "cls-1",
    d: "M0,0H8.956V9.955H0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_1",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 1",
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_79",
    "data-name": "\\uD328\\uC2A4 79",
    className: "cls-3",
    d: "M0,0V6.426",
    transform: "translate(4.478 0.472)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_78",
    "data-name": "\\uD328\\uC2A4 78",
    className: "cls-4",
    d: "M7.292,4.437,4.583,7.146,1.874,4.437",
    transform: "translate(-0.105 -0.248)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_223",
    "data-name": "\\uC120 223",
    className: "cls-4",
    x2: 8.012,
    transform: "translate(0.472 9.483)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManual);
export default __webpack_public_path__ + "static/media/Manual.f96addb78a38f32c77de77652dd8af08.svg";
export { ForwardRef as ReactComponent };